import type { Schedule as EngineSchedule } from "@smartsuite/automation-engine-api";
import { useRootStore } from "../../../../../../../../stores/hooks";

interface ScheduleConverter {
  convert: (schedule: EngineSchedule) => void;
}

export const useScheduleConverter = (): ScheduleConverter => {
  const { scheduleStore } = useRootStore();
  const convert = (schedule: EngineSchedule): void => {
    scheduleStore.setSchedule(schedule.schedule);
  };

  return {
    convert,
  };
};
